import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar1 from "../Navbar/Navber1";

const Layout = ({ toggle, menuOpen }) => {
  return (
    <div className="">
      <Navbar1 toggle={toggle} menuOpen={menuOpen} />
      <Outlet />
      {/* <div className='w-100'>
                <Footer />
            </div> */}
    </div>
  );
};

export default Layout;
